export default {
  path: 'project-list',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Project List',
      component: () => import('@/views/menus/projectList/Index'),
      meta: {
        permission: true
      }
    }
  ]
}
